import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CONSTANTS } from '../constants/constants';
import { map, Observable } from 'rxjs';
import { EventResponseEvent } from '../types/event-response.type';
import { SearchQueryParams } from '../types/ui.type';

@Injectable({
  providedIn: 'root',
})
export class CalendarHttpService {
  private url = `${CONSTANTS.BASE_API}calendar`;

  constructor(private readonly http: HttpClient) {}

  getEvents({
    userId,
    userLikedEvents,
    userFollowedOrganizations,
    userFollowedSports,
  }: SearchQueryParams = {}): Observable<EventResponseEvent[]> {
    let params: HttpParams = new HttpParams();

    if (userId) {
      params = params.append('user_id', userId);

      if (userLikedEvents) {
        params = params.append('user_liked_events', 1);
      }

      if (userFollowedOrganizations) {
        params = params.append('user_followed_organizations', 1);
      }

      if (userFollowedSports) {
        params = params.append('user_followed_categories', 1);
      }
    }

    return this.http
      .get<EventResponseEvent[]>(this.url, { params })
      .pipe(map((res) => res));
  }
}
